/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ClinicalDictionaryType from './clinical-dictionary-type';
import ClinicalDictionaryTypeDetail from './clinical-dictionary-type-detail';
import ClinicalDictionaryTypeUpdate from './clinical-dictionary-type-update';
import ClinicalDictionaryTypeDeleteDialog from './clinical-dictionary-type-delete-dialog';

const ClinicalDictionaryTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ClinicalDictionaryType />} />
    <Route path="new" element={<ClinicalDictionaryTypeUpdate />} />
    <Route path=":id">
      <Route index element={<ClinicalDictionaryTypeDetail />} />
      <Route path="edit" element={<ClinicalDictionaryTypeUpdate />} />
      <Route path="delete" element={<ClinicalDictionaryTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ClinicalDictionaryTypeRoutes;
